module.exports = __webpack_public_path__ + "img/attact-branch.6c5fc1aa.png";